export const DEFAULT_STUDIO_CATEGORY_SLUG = 'templates';
export const DEFAULT_NEW_STUDIO_CATEGORY_SLUG = 'all-templates';
export const DESIGNED_TEMPLATES_CATEGORY_SLUG = 'designed-templates';
export const BLANK_TEMPLATE_META_SITE_ID =
  'fe86a14e-ef67-49b4-a409-d086f3abaa1a';
export const JOIN_WAIT_LIST_URL = 'https://www.wix.com/studio/waitlist';
export const STUDIO_LANDING_URL = 'https://www.wix.com/studio';
export const VIEW_BASEURL = 'https://www.wix.com/website-template/view/html';
export const EDIT_TEMPLATE_URL = 'https://editor.wix.com/edit-template/from';
export const SITELESS_EDIT_TEMPLATE_URL =
  'https://editor.wix.com/edit-template/from-intro-siteless';
export const SOCIAL_MEDIA_THUMBNAIL_URL =
  'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/social-media/wix_studio_social_thumbnail_1200X628.jpg';
export const SUPPORTED_LANGUAGES = ['en', 'es', 'fr', 'de', 'ja', 'pt'];

interface CategoryGroup {
  title: string;
  categorySlugs: string[];
}

export const CATEGORY_GROUPS: CategoryGroup[] = [
  {
    title: 'app.new.bucket.category',
    categorySlugs: ['all-templates', 'designed-templates', 'wireframes'],
  },
  {
    title: 'app.new.bucket.type',
    categorySlugs: ['ecommerce', 'type-portfolio', 'one-page', 'company-site'],
  },
  {
    title: 'app.new.bucket.industry',
    categorySlugs: ['business', 'technology', 'creative', 'fashion-beauty'],
  },
  {
    title: 'app.new.bucket.features',
    categorySlugs: ['stores', 'bookings', 'feature-portfolio', 'blog'],
  },
  {
    title: 'app.new.bucket.style',
    categorySlugs: ['dark', 'minimal', 'illustrative', 'typography'],
  },
];
